export const css = {
	root: '_3gqQj070',
	heading: '_3DM-jz0q',
	row: '_30GA6W34',
	product: 'u1yPlLmd',
	primary: '_1ZkuFqpo',
	secondary: '_2QLtNxiB',
	sticky: '_1R7Sh1T4',
	leading: '_3TxeUV8J',
	title: '_2O427GFA',
	actions: 'zXr3hMDG',
	trailing: '_2zGJn2FB',
	spacer: '_2B5x_ezl',
	hamburgerWrapper: 'PcsUmYcJ',
	hamburger: '_2YDBwJ64',
	hamburgerText: '_3d6Eyiyk',
	hamburgerMenu: '_1jrIjB1R',
	hamburgerMenuItem: '_6mX7pBLS',
	quizSelect: '_1rB0AUAf',
	quizSelectBlock: '_25HmsoRo',
	hideCountdownBlock: '_2QwJ5OiS',
	quizSelectChoice: '_2n9GBfiT',
	quizSelectHidden: '_3H2yXhQO',
	examCalendar: '_27KsjzB5',
	selectFadeOut: '_3aPUOgno',
	' _key': 'certwise-theme/certwise/lcc-app/heading'
};

export default css;
